import {
  GlobalEvents,
  SnippetElement,
  defineElement,
  liquidValue,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-swiper/util-swiper.ts
var UtilSwiper = class extends SnippetElement {
  connectedCallback() {
    this.init();
  }
  prev() {
    var _a;
    (_a = this.swiperInstance) == null ? void 0 : _a.slidePrev();
  }
  next() {
    var _a;
    (_a = this.swiperInstance) == null ? void 0 : _a.slideNext();
  }
  getAutoplay() {
    if (this.autoplay == null || this.autoplay === false || typeof this.autoplay === "boolean") {
      return void 0;
    }
    return JSON.parse(this.autoplay);
  }
  addFocusEventListener() {
    console.log("Adding focus event listener");
    this.swiperElm.addEventListener("focusin", (e) => {
      var _a;
      const slide = e.target.closest(".swiper-slide");
      if (slide != null) {
        const index = Array.from(this.swiperElm.querySelectorAll(".swiper-slide")).indexOf(slide);
        if (index !== -1) {
          (_a = this.swiperInstance) == null ? void 0 : _a.slideTo(index);
        }
      }
    });
  }
  updateButtons() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
    if (this.buttonsEndReached === "hide") {
      if (((_a = this.swiperInstance) == null ? void 0 : _a.isBeginning) && ((_b = this.swiperInstance) == null ? void 0 : _b.isEnd)) {
        (_c = this.prevButton) == null ? void 0 : _c.classList.add("opacity-0", "pointer-events-none");
        (_d = this.nextButton) == null ? void 0 : _d.classList.add("opacity-0", "pointer-events-none");
      } else if ((_e = this.swiperInstance) == null ? void 0 : _e.isBeginning) {
        (_f = this.prevButton) == null ? void 0 : _f.classList.add("opacity-0", "pointer-events-none");
        (_g = this.nextButton) == null ? void 0 : _g.classList.remove("opacity-0", "pointer-events-none");
      } else if ((_h = this.swiperInstance) == null ? void 0 : _h.isEnd) {
        (_i = this.prevButton) == null ? void 0 : _i.classList.remove("opacity-0", "pointer-events-none");
        (_j = this.nextButton) == null ? void 0 : _j.classList.add("opacity-0", "pointer-events-none");
      } else {
        (_k = this.prevButton) == null ? void 0 : _k.classList.remove("opacity-0", "pointer-events-none");
        (_l = this.nextButton) == null ? void 0 : _l.classList.remove("opacity-0", "pointer-events-none");
      }
    } else if (this.buttonsEndReached === "disable") {
      if (((_m = this.swiperInstance) == null ? void 0 : _m.isBeginning) && ((_n = this.swiperInstance) == null ? void 0 : _n.isEnd)) {
        (_o = this.prevButton) == null ? void 0 : _o.setAttribute("disabled", "");
        (_p = this.prevButton) == null ? void 0 : _p.classList.add("pointer-events-none");
        (_q = this.nextButton) == null ? void 0 : _q.setAttribute("disabled", "");
        (_r = this.nextButton) == null ? void 0 : _r.classList.add("pointer-events-none");
      } else if ((_s = this.swiperInstance) == null ? void 0 : _s.isBeginning) {
        (_t = this.prevButton) == null ? void 0 : _t.setAttribute("disabled", "");
        (_u = this.prevButton) == null ? void 0 : _u.classList.add("pointer-events-none");
        (_v = this.nextButton) == null ? void 0 : _v.removeAttribute("disabled");
        (_w = this.nextButton) == null ? void 0 : _w.classList.remove("pointer-events-none");
      } else if ((_x = this.swiperInstance) == null ? void 0 : _x.isEnd) {
        (_y = this.prevButton) == null ? void 0 : _y.removeAttribute("disabled");
        (_z = this.prevButton) == null ? void 0 : _z.classList.remove("pointer-events-none");
        (_A = this.nextButton) == null ? void 0 : _A.setAttribute("disabled", "");
        (_B = this.nextButton) == null ? void 0 : _B.classList.add("pointer-events-none");
      } else {
        (_C = this.prevButton) == null ? void 0 : _C.removeAttribute("disabled");
        (_D = this.prevButton) == null ? void 0 : _D.classList.remove("pointer-events-none");
        (_E = this.nextButton) == null ? void 0 : _E.removeAttribute("disabled");
        (_F = this.nextButton) == null ? void 0 : _F.classList.remove("pointer-events-none");
      }
    }
  }
  init() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
      const { Swiper, Autoplay, Pagination } = yield import("./swiper.esm-QLJ6PWS5.js");
      this.classList.remove("swiper-init");
      this.swiperInstance = new Swiper(this.swiperElm, {
        modules: [Autoplay, Pagination],
        on: {
          afterInit: () => __async(this, null, function* () {
            yield new Promise((resolve) => setTimeout(resolve, 1));
            if (this.globalEventName != null) {
              GlobalEvents.emit(`${this.globalEventName}:init`);
            }
            this.updateButtons();
            this.addFocusEventListener();
          })
        },
        watchSlidesProgress: (_a = this.watchSlidesProgress) != null ? _a : false,
        direction: (_b = this.direction) != null ? _b : "horizontal",
        autoHeight: (_c = this.autoHeight) != null ? _c : true,
        height: (_d = this.height) != null ? _d : null,
        loop: (_e = this.loop) != null ? _e : false,
        allowTouchMove: (_f = this.allowTouchMove) != null ? _f : true,
        centeredSlides: (_g = this.centeredSlides) != null ? _g : true,
        effect: (_h = this.effect) != null ? _h : "slide",
        focusableElements: (_i = this.focusableElements) != null ? _i : "input, select, option, textarea, button, video, label",
        enabled: (_j = this.enabled) != null ? _j : true,
        followFinger: (_k = this.followFinger) != null ? _k : true,
        grabCursor: (_l = this.grabCursor) != null ? _l : false,
        preloadImages: (_m = this.preloadImages) != null ? _m : true,
        preventClicks: (_n = this.preventClicks) != null ? _n : true,
        resistance: (_o = this.resistance) != null ? _o : true,
        resistanceRatio: (_p = this.resistanceRatio) != null ? _p : 0.85,
        rewind: (_q = this.rewind) != null ? _q : false,
        roundLengths: (_r = this.roundLengths) != null ? _r : false,
        simulateTouch: (_s = this.simulateTouch) != null ? _s : true,
        slidesPerGroup: (_t = this.slidesPerGroup) != null ? _t : 1,
        slidesPerView: (_u = this.slidesPerView) != null ? _u : 1,
        speed: (_v = this.speed) != null ? _v : 300,
        spaceBetween: (_w = this.spaceBetween) != null ? _w : 10,
        watchOverflow: (_x = this.watchOverflow) != null ? _x : false,
        centerInsufficientSlides: (_y = this.centerInsufficientSlides) != null ? _y : false,
        breakpoints: this.breakpoints != null ? JSON.parse(this.breakpoints) : null,
        pagination: this.pagination ? {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return '<span class="' + className + '"></span>';
          }
        } : false,
        autoplay: this.getAutoplay()
      });
      if (!this.loop) {
        this.swiperInstance.on("breakpoint", () => {
          this.updateButtons();
        });
        this.swiperInstance.on("reachEnd", () => {
          this.updateButtons();
        });
        this.swiperInstance.on("reachBeginning", () => {
          this.updateButtons();
        });
        this.swiperInstance.on("touchMove", () => {
          this.updateButtons();
        });
        this.swiperInstance.on("slideChange", () => {
          this.updateButtons();
        });
      }
    });
  }
};
__decorateClass([
  liquidValue("watchOverflow")
], UtilSwiper.prototype, "watchOverflow", 2);
__decorateClass([
  liquidValue("pagination")
], UtilSwiper.prototype, "pagination", 2);
__decorateClass([
  liquidValue("globalEventName")
], UtilSwiper.prototype, "globalEventName", 2);
__decorateClass([
  liquidValue("breakpoints")
], UtilSwiper.prototype, "breakpoints", 2);
__decorateClass([
  liquidValue("loop")
], UtilSwiper.prototype, "loop", 2);
__decorateClass([
  liquidValue("direction")
], UtilSwiper.prototype, "direction", 2);
__decorateClass([
  liquidValue("autoHeight")
], UtilSwiper.prototype, "autoHeight", 2);
__decorateClass([
  liquidValue("allowTouchMove")
], UtilSwiper.prototype, "allowTouchMove", 2);
__decorateClass([
  liquidValue("watchSlidesProgress")
], UtilSwiper.prototype, "watchSlidesProgress", 2);
__decorateClass([
  liquidValue("buttonsEndReached")
], UtilSwiper.prototype, "buttonsEndReached", 2);
__decorateClass([
  liquidValue("centeredSlides")
], UtilSwiper.prototype, "centeredSlides", 2);
__decorateClass([
  liquidValue("effect")
], UtilSwiper.prototype, "effect", 2);
__decorateClass([
  liquidValue("focusableElements")
], UtilSwiper.prototype, "focusableElements", 2);
__decorateClass([
  liquidValue("enabled")
], UtilSwiper.prototype, "enabled", 2);
__decorateClass([
  liquidValue("centerInsufficientSlides")
], UtilSwiper.prototype, "centerInsufficientSlides", 2);
__decorateClass([
  liquidValue("height")
], UtilSwiper.prototype, "height", 2);
__decorateClass([
  liquidValue("followFinger")
], UtilSwiper.prototype, "followFinger", 2);
__decorateClass([
  liquidValue("grabCursor")
], UtilSwiper.prototype, "grabCursor", 2);
__decorateClass([
  liquidValue("preloadImages")
], UtilSwiper.prototype, "preloadImages", 2);
__decorateClass([
  liquidValue("preventClicks")
], UtilSwiper.prototype, "preventClicks", 2);
__decorateClass([
  liquidValue("resistance")
], UtilSwiper.prototype, "resistance", 2);
__decorateClass([
  liquidValue("resistanceRatio")
], UtilSwiper.prototype, "resistanceRatio", 2);
__decorateClass([
  liquidValue("rewind")
], UtilSwiper.prototype, "rewind", 2);
__decorateClass([
  liquidValue("roundLengths")
], UtilSwiper.prototype, "roundLengths", 2);
__decorateClass([
  liquidValue("simulateTouch")
], UtilSwiper.prototype, "simulateTouch", 2);
__decorateClass([
  liquidValue("slidesPerGroup")
], UtilSwiper.prototype, "slidesPerGroup", 2);
__decorateClass([
  liquidValue("slidesPerView")
], UtilSwiper.prototype, "slidesPerView", 2);
__decorateClass([
  liquidValue("speed")
], UtilSwiper.prototype, "speed", 2);
__decorateClass([
  liquidValue("spaceBetween")
], UtilSwiper.prototype, "spaceBetween", 2);
__decorateClass([
  liquidValue("autoplay")
], UtilSwiper.prototype, "autoplay", 2);
__decorateClass([
  query(".swiper")
], UtilSwiper.prototype, "swiperElm", 2);
__decorateClass([
  query("[data-prev]")
], UtilSwiper.prototype, "prevButton", 2);
__decorateClass([
  query("[data-next]")
], UtilSwiper.prototype, "nextButton", 2);
__decorateClass([
  onClick("[data-prev]")
], UtilSwiper.prototype, "prev", 1);
__decorateClass([
  onClick("[data-next]")
], UtilSwiper.prototype, "next", 1);
UtilSwiper = __decorateClass([
  defineElement("util-swiper")
], UtilSwiper);
export {
  UtilSwiper
};
